import type {ReactNode} from 'react';
import type {TextSize} from '@Components/text';

export enum PillSize {
  SM = 'sm',
  MD = 'md',
}

export enum PillType {
  NEUTRAL = 'neutral',
  BRAND = 'brand',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  PREMIUM = 'premium',
  PREMIUM_PLUS = 'premiumPlus',
  AI = 'ai',
}

export interface PillProps {
  label: string;
  type?: PillType;
  size?: PillSize;
  labelSize?: TextSize;
  isFilled?: boolean;
  isTruncatable?: boolean;
  isDisabled?: boolean;
  icon?: string;
  /** An icon with no icon-font glyph (an inline SVG), drawn in the icon slot in the pill's colour; `icon` is ignored then. */
  iconElement?: ReactNode;
  className?: string;
  'data-testid'?: string;
}
